// Shared types between web and mobile apps

export interface User {
  id: number;
  email: string;
  name: string;
  provider?: string;
  createdAt: string;
  updatedAt: string;
}

export interface Transaction {
  id: number;
  description: string;
  rawDescription?: string;
  amount: number;
  date: string;
  type: 'INCOME' | 'EXPENSE' | 'TRANSFER';
  isTransfer?: boolean;
  category?: {
    id: number;
    name: string;
    color: string;
    icon: string;
  };
  account?: {
    id: number;
    name: string;
    type: string;
  };
  splits?: {
    id: number;
    amount: number;
    label?: string | null;
    category: { id: number; name: string; color?: string };
  }[];
  tags?: { id: number; name: string; color?: string }[];
  // Refund linking: returns netted against the purchase they refund
  refundTotal?: number;
  refundCount?: number;
  refundItems?: { id: number; amount: number; date: string; name: string }[];
  refundsTransactionId?: number | null;
  refundsTargetName?: string | null;
  // Work expenses: the day the receipt was sent to the employer, null while
  // it is still waiting to be claimed
  reimbursementSubmittedAt?: string | null;
  isPredicted?: boolean; // For future/predicted transactions
}

// Categories whose expenses are expected to be reimbursed (netted by
// incoming payments) - shown with a "Kvittas" badge in transaction lists
export const REIMBURSABLE_CATEGORIES = ['Utlägg jobb'];

export interface Category {
  id: number;
  name: string;
  color: string;
  icon: string;
  parentId?: number;
}

export interface Account {
  id: number;
  name: string;
  type: string;
  balance: number;
}

export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
}

export interface TransactionsResponse {
  success: boolean;
  transactions: Transaction[];
  error?: string;
  message?: string;
  pagination?: {
    page: number;
    limit: number;
    totalCount: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  };
}
